<template>
  <!-- <ion-toolbar>
      <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
        <ion-button class="button_back">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar> -->
  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName == 'locum_jobseeker_enhance'">
      <ion-button color="warning" class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" v-if="routeName != 'locum_jobseeker_enhance'">
      <ion-button data-testid="directions-108" @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    

    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Enhance Profile</h1>
          <p class="auth-subtext">Use AI to help you generate content for your profile. Don't worry, you will have full
            edit access to perfect your profile before it is published</p>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
        </div>
      </div>
      <AiLoading :isUS="isUS" :isAustralia="isAustralia" :isLoading="isLoading" @stopLoading="handleSubmit" />
      <el-form class="full_page" :model="form" ref="userForm" label-position="top">
    
        <el-form-item :show-message="false" class="no-scroll"
          prop="enhance_profile">
         
            
            <div>
              <p class="main-title-ai">Professional statement</p>
              <p class="main-title-ai">Skills and expertise</p>
              <p class="main-title-ai">Education and Certifications</p>
            </div>
           
          
        </el-form-item>

        <!-- Button to submit the form -->
        <el-form-item class="button_submit mb0">
          <el-button class="submit" type="primary btn-primary" data-testid="directions-113"
            @click="handleSubmit">
            Continue
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
  
<script setup>
import { reactive, inject, onMounted,ref } from 'vue';

import { useRouter, useRoute } from 'vue-router';
import { useStore } from "vuex";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import AiLoading from '@/components/AiLoading/AiLoading.vue';
const setPageClassGlobal = inject(['setPageClassGlobal']);
const $router = useRouter();
const $route = useRoute();
const $store = useStore();
const form = reactive({
  enhance_profile: [],

});
const routeName = $route.name;

const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();
    const isLoading = ref(false);



const goBack = () => {
    // $router.push({
    //   name: 'jobseeker_auth_cv',
    // });
    
  if (routeName == 'locum_jobseeker_enhance') {
    $router.push({
      name: "locum_jobseeker_cv",
    });
  } else {
    $router.push({
      name: $store.getters.getAuthPageBack,
    });
  }
};


const goNext = () => {

  if(routeName == 'locum_jobseeker_enhance'){
            $router.push({
              name: "locum_jobseeker_preview",
            });

           }else{
            $router.push({
              name: 'jobseeker_auth_preview',
            });
           }
  
};

const skip = () => {
      (async () => {
       
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
         goNext();
        } catch (error) {
          console.log(error);
        }
      })();
    };




const handleSubmit = async () => {
  const all = {
    enhance_profile: ["Professional statement","Skills and expertise","Education and Certifications"]
    
  }
  // const result = await v$.value.$validate();
  console.log("🚀 ~ handleSubmit ~ result:", all);
  // if (!result) {
  //   alert('The form has errors');
  //   return;
  // }
  (async () => {
    try {
      isLoading.value = true;

      (async () => {
          try {
            await $store.dispatch("SAVE_JOB_ENHANCE", all);
          } finally {
           
            isLoading.value = false;
            goNext();
          }
        })();


      
      
    } catch (error) {
      console.log("error submit!!");
    }
  })();
  // goNext();
  // alert('Form submitted successfully');
};

onMounted(() => {
  setPageClassGlobal('global_auth_page');
  // validateField('enhance_profile');
});


console.log("🚀 ~ setup ~ v$.enhance_profile.$error", skip)
</script>
  
<style scoped>
/* Add your custom styles here */
</style>
  